import * as React from 'react';
import { SVGProps } from 'react';

const IconBagSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h2a1 1 0 0 1 1 1v.5L6.469 5.93a1.7 1.7 0 0 1-.938 0L0 4.5V4a1 1 0 0 1 1-1h2V2zm1 1h4V2H4v1z"
    />
    <path d="M6.656 6.9 12 5.5V10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5.5l5.344 1.4c.433.156.879.156 1.312 0z" />
  </svg>
);
export default IconBagSizeXs;
